import ReactDOM from "react-dom/client";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./Styles/theme";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./Context/authContext";
import { I18nextProvider } from "react-i18next";
import i18n from "./Language/langConfig";
import { NavigationBlockerProvider } from "./Context/navigationBlockerContext";
import ErrorBoundary from "./Components/errorBoundary";
import { ErrorProvider } from "./Context/errorContext";
import WithErrorBoundary from "./Components/errorAlertBoundary";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AuthProvider>
    <I18nextProvider i18n={i18n}>
      <ThemeProvider theme={theme}>
        <NavigationBlockerProvider>
          <ErrorBoundary>
            <ErrorProvider>
              <WithErrorBoundary>
                <App />
              </WithErrorBoundary>
            </ErrorProvider>
          </ErrorBoundary>
        </NavigationBlockerProvider>
      </ThemeProvider>
    </I18nextProvider>
  </AuthProvider>
);

reportWebVitals();
